export const defaultAuthoringSystem: string = 'communicare';
export const selfAuthoringSystemForeignKey: string = 'self';
export const emptyGuid: string = '00000000-0000-0000-0000-000000000000';
export const dosageTimesBreakfastAndMorning: string[] = [
    '06:00',
    '06:30',
    '07:00',
    '07:30',
    '08:00',
    '08:30',
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30'
];
export const dosageTimesLunchAndAfternoon: string[] = [
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30'
];
export const dosageTimesDinner: string[] = [
    '18:00',
    '18:30',
    '19:00',
    '19:30',
    '20:00',
    '20:30',
    '21:00',
    '21:30',
    '22:00',
    '22:30',
    '23:00',
    '23:30'
];
export const dosageTimesBedtimeAndNight: string[] = [
    '00:00',
    '00:30',
    '01:00',
    '01:30',
    '02:00',
    '02:30',
    '03:00',
    '03:30',
    '04:00',
    '04:30',
    '05:00',
    '05:30'
];

// This is a list of the keys we’ll use to store data in local storage.
// By defining them as constants, we avoid mistakes like typos.
// It’s TypeScript’s way of keeping us in check.
export const StorageKeys = {
    SAVED_CACHE_PATEINT_INFO: 'patientInfo',
    SAVED_CACHE_PATEINT_IMAGE: 'patientImage'
} as const;

// This is a TypeScript thing that makes sure we only use the keys we’ve defined in StorageKeys.
// It’s all about being safe and avoiding errors.
export type StorageKeysType = typeof StorageKeys[keyof typeof StorageKeys];

// Max length for the medication fields
export const MAX_LENGTH_PACK_SIZE_FIELD = 5;
export const MAX_LENGTH_QUANTIY_FIELD = 9;
export const MAX_LENGTH_NUMBER_OF_PACKS_FIELD = 9;
export const MAX_INFUSION_INSTRUCTIONS_LENGTH = 500;
export const MAX_LENGTH_MAX_DOSE_PER_24HR_FIELD = 100;
export const MAX_LENGTH_DOSAGE_INSTRUCTIONS_FIELD = 250;

// Table Pagination Page Size
export const PaginationPageSizeAdministration = 20;

// Variable dose
export const MAX_VARIABLE_DOSE_STEPS = 15;
